/**
 * Quill zapisuje pustą linię jako <p><br></p>, co daje zbyt duży odstęp przez margines <p>.
 * Zamienia takie puste akapity na pojedyncze <br>.
 */
export default function normalizeCertificationDescriptionHtml(html) {
  if (!html) {
    return html
  }

  return String(html).replace(/<p>\s*<br\s*\/?>\s*<\/p>/gi, '<br>')
}
